import React, { Fragment, Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { LinearProgress } from '@material-ui/core';
import { Topbar } from './components';

const useStyles = makeStyles(theme => ({
  content: {
    height: '100%',
    paddingTop: 56,
    [theme.breakpoints.up('sm')]: {
      paddingTop: 64,
    },
  },
  contentFullPage: {
    height: '100%',
  },
}));

const FULL_PAGE_ROUTES = ['/auth/login'];

const Auth = () => {
  const classes = useStyles();
  const location = useLocation();
  const isFullPage = FULL_PAGE_ROUTES.includes(location.pathname);

  return (
    <Fragment>
      {!isFullPage && <Topbar />}
      <main className={isFullPage ? classes.contentFullPage : classes.content}>
        <Suspense fallback={<LinearProgress />}>
          <Outlet />
        </Suspense>
      </main>
    </Fragment>
  );
};

export default Auth;
